import ReactDOM from 'react-dom/client'
import './index.css'
import App from './components/App'
import SignIn from './components/Auth/SignIn'
import {AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate} from '@azure/msal-react'
import {msalConfig} from './auth/auth-config'
import {PublicClientApplication} from '@azure/msal-browser'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'

const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <MsalProvider instance={msalInstance}>
    <UnauthenticatedTemplate>
      <SignIn />
    </UnauthenticatedTemplate>
    <AuthenticatedTemplate>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <App />
      </LocalizationProvider>
    </AuthenticatedTemplate>
  </MsalProvider>
)
